/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { useState, useEffect, useContext } from 'react';
import './JobsSearchLanding.scss';
import Layout from '../../../components/Layout/Layout';
import { PageContext } from '../../../contexts/ContextCreator';
import JobSearchProvider from '../../../contexts/JobSearchContext';
import { JobsSearch } from '../../../components/JobV3/JobsSearch/JobsSearch';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

/**
 * Manage the jobs landing page
 */
function JobsSearchLanding(props) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);

    const { jobSearchBar, jobPage } = props;
    const { pageProps, isLoggedIn, jobNotifications: jobAlerts } = useContext(
        PageContext
    );
    const { featureFlags } = pageProps;

    const jobSearch = {
        jobSearchTerm: jobSearchBar.keywords,
        jobLocation: jobSearchBar.location || '',
        jobLng: Number(jobSearchBar.lng),
        jobLat: Number(jobSearchBar.lat),
    };
    // check the props.filters.company_id and compare to the list of  prop.facets.company_id and add the diplaynames to the filters
    const { filters } = props;
    if (filters && props.facets) {
        const companyIds = filters.company_id;
        const companyFacets = props.facets.company_id;
        if (companyIds && companyFacets) {
            const companyNames = companyIds.map((id) => {
                const company = companyFacets.find((facet) => facet.value === id);
                return company ? company.displayName : '';
            });
            filters.company_name = companyNames;
        }
    }

    const minimizedJobsLeftRail =
        featureFlags && featureFlags.minimizedJobsLeftRail;

    const isAuthenticatedUser = isLoggedIn();
    return (
        mounted && (
            <div className="page-JobV3-JobsSearchLanding">
                <SnowplowPageViewTracker
                    pageSection={PAGE_VIEW_SECTIONS.SEARCH}
                    pageType={PAGE_VIEW_TYPES.COLLECTION}
                />
                <Layout
                    PAGE_PROPS={pageProps}
                    hasChangingContainer={false}
                    topBannerOnlyShownList={['job-seeker-profile']}
                    displayDesktopFooter={!minimizedJobsLeftRail}
                >
                    <JobSearchProvider
                        pageLimit={props?.limit}
                        isAuthenticatedUser={isAuthenticatedUser}
                        _page={props.page}
                        baseUrl="/jobs/find"
                        _jobSearch={jobSearch}
                        jobsTotal={props.total}
                        _content={props.jobs}
                        _searchQueryId={props.queryID}
                        searchIndexName={props.indexName}
                        _activeFilters={filters}
                        _filters={props.facets}
                        jobUrl={jobPage}
                        jobAlerts={jobAlerts}
                        CTAJobSearch={props?.CTAJobSearch}
                    >
                        <JobsSearch />
                    </JobSearchProvider>
                </Layout>
            </div>
        )
    );
}

export default JobsSearchLanding;
JobsSearchLanding.propTypes = {
    jobs: PropTypes.array.isRequired,
    jobSearchBar: PropTypes.shape({
        keywords: PropTypes.string.isRequired,
        lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        location: PropTypes.string,
        page: PropTypes.string,
        searchBarTitle: PropTypes.string,
        searchTermPlaceholder: PropTypes.string,
    }),
    pagination: PropTypes.shape({
        prevUrl: PropTypes.string,
        nextUrl: PropTypes.string,
    }),
    page: PropTypes.number,
    userJobProfile: PropTypes.shape({
        hash: PropTypes.string,
        isCompleted: PropTypes.bool,
    }),
    total: PropTypes.number,
    filters: PropTypes.object,
    facets: PropTypes.object,
    queryID: PropTypes.string,
    indexName: PropTypes.string,
    jobPage: PropTypes.string,
    limit: PropTypes.number,
    CTAJobSearch: PropTypes.bool,
};

JobsSearchLanding.defaultProps = {
    total: 0,
    filters: {},
    facets: {},
    jobPage: '',
    CTAJobSearch: null,
};
